import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, getDigToken } from '@/utils/auth'
import { parsePath } from '@/utils/parse'
import _ from 'lodash'
// process.env.NODE_ENV: "development"
// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : '/dev-api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
      config.headers['x-csrf-token'] = getDigToken()
    }
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['user-token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log('reqErr:', error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 403 请求不满足条件，被拒绝
      if (res.code === 403 || res.code === 422 || res.code === 423) {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }

      // 426 商品已下架或停售
      if (res.code === 426) {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000,
          onClose: () => {
            window.location.href = '/'
          }
        })
      }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('您的登陆状态已过期，请重新登陆', '提示', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            // 跳转到登录页
            window.location.href = '/login.html'
            // location.reload()
          })
        })
      }

      // 50016: 用户未登录
      if (res.code === 50016) {
        // to re-login
        MessageBox.confirm('您还没有登陆登陆，请登陆操作！', '提示', {
          confirmButtonText: '前往登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            // 跳转到登录页
            window.location.href = '/login.html'
          })
        })
      }

      // 50018: 用户未激活
      if (res.code === 50018) {
        // to re-login
        MessageBox.confirm('请同意《商城服务协议》等相关协议，以便您的账户可以正常使用！', '提示', {
          confirmButtonText: '立即浏览',
          cancelButtonText: '稍后再说',
          type: 'warning'
        }).then(() => {
          // 当前页面地址
          const fullPath = window.location.href
          const pagePath = fullPath.slice(0, fullPath.indexOf('#'))
          const absolutePath = fullPath.slice(pagePath.lastIndexOf('/'))
          window.location.href = absolutePath ? `/login.html#/activate?redirect=${encodeURIComponent(absolutePath)}` : '/login.html#/activate'
        }).catch(() => {})
      }

      // 50020: 账户已停用
      if (res.code === 50020) {
        // to re-login
        MessageBox.confirm('您的账户已停用，请联系商城客服！', '提示', {
          cancelButtonText: '稍后再说',
          showConfirmButton: false,
          type: 'error'
        }).then(() => {}).catch(() => {
          const { query } = parsePath(window.location.href)
          window.location.href = query.redirect ? decodeURIComponent(query.redirect) : '/'
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // error.response 获取状态码非200的返回信息
    const status = error.response.status
    let message = error.message
    switch (status) {
      case 403:
        //  csrf 报错  重置safeToken
        if (error.response.data.message === 'invalid csrf token') {
          message = '您的安全码已过期，正在为您更新！'
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }
        break
      case 422:
        // ( value, key)
        message = ''
        _.forEach(error.response.data.detail, value => {
          message += `${value.field}: ${value.message}; `
        })
        break
      default:
        message = error.message
    }
    Message({
      message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js